<script lang="ts" setup>
import { getCards } from '@/helpers/cards'
import type { TUiTypeValues } from '../../../types/api/reports'

defineProps<{ board: TUiTypeValues['hand'] }>()
</script>

<template>
  <div class="gwboard">
    <div
      v-for="(card, idx) in getCards(board)"
      :key="card + idx + 'cardrow'"
      :class="`gwboard gwboard_card gwboard_card_${card[1]}`"
    >
      {{ card[0] }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gwboard {
  display: flex;
  gap: 2px;
  &_card {
    border-radius: 2px;
    position: relative;
    font-weight: 600;
    color: white;
    padding: 0 0.25rem;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &:before {
      content: '';
      position: absolute;
      inset: -0.125rem 0 0 0;
      width: 100%;
      height: calc(100% + 0.25rem);
      background: var(--card-clr);
      border-radius: 10%;
      z-index: -1;
    }
    &_h {
      --card-clr: var(--clr-hearts);
    }
    &_s {
      --card-clr: var(--clr-spades);
    }
    &_d {
      --card-clr: var(--clr-diamonds);
    }
    &_c {
      --card-clr: var(--clr-clubs);
    }
  }
}
</style>
